import { render, staticRenderFns } from "./DynamicContentClientApp.vue?vue&type=template&id=7b9622c4"
import script from "./DynamicContentClientApp.vue?vue&type=script&lang=js"
export * from "./DynamicContentClientApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports